import { CompanySizeOptionKey, CountryOptionKey, DepartmentOptionKey, IndustryOptionKey, MainSolutionKey, StateOptionKey } from "../../../locale/translation-keys/all-keys.js";

import type { MarketoUserInputMetaObject } from "./marketo-input-meta.js";
import type { UserMarketoInputName } from "./marketo-input-names-and-values.js";

type SelectBoxFieldsType<EnabledFields extends UserMarketoInputName = UserMarketoInputName> = {
  [K in EnabledFields]: MarketoUserInputMetaObject[K] extends { type: "select"; } ? K : never;
}[EnabledFields];
  
const FormOptions = {
  "Country": CountryOptionKey,
  "State": StateOptionKey,
  "Department__c": DepartmentOptionKey,
  "Industry": IndustryOptionKey,
  "Tier__c": CompanySizeOptionKey,
  "Latest_Solution_Interest__c": MainSolutionKey
} satisfies {
  [K in SelectBoxFieldsType]: readonly string[]
};

export type DropdownInputName = keyof typeof FormOptions;
export const DropdownInputName = Object.keys(FormOptions) as DropdownInputName[];

export function getFormDropdownOptionKeys<EnabledField extends DropdownInputName>(selectFields: readonly EnabledField[]) {
  return selectFields.reduce((result, inputName) => {
    result[inputName] = FormOptions[inputName];
    return result;
  }, {} as { [K in EnabledField]: readonly string[] });
  
}